/**
 * Whether a destination is a SIP identifier rather than a number.
 *
 * Anything that is neither all digits nor E.164 is a name — an extension, a
 * queue — and then the resolved phone number is a separate fact worth showing
 * next to it.
 */
export const isSipIdentifier = (
  value: string | null | undefined
): boolean => {
  if (!value) {
    return false;
  }

  return !/^\d+$/.test(value) && !value.startsWith('+');
};
